import api from './api';

/**
 * Service for On-Demand Healthcare worker management
 */
class OnDemandHCWService {
  static async getHCWs({ search, approvalStatus, isActive } = {}) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (approvalStatus) params.append('approvalStatus', approvalStatus);
    if (isActive !== undefined) params.append('isActive', isActive);
    
    const query = params.toString();
    return api.get(`/ondemand/hcws${query ? `?${query}` : ''}`);
  }

  static async getHCW(id) {
    return api.get(`/ondemand/hcws/${id}`);
  }

  static async createHCW(data) {
    return api.post('/ondemand/hcws', data);
  }

  static async updateHCW(id, data) {
    return api.put(`/ondemand/hcws/${id}`, data);
  }

  static async deleteHCW(id) {
    return api.delete(`/ondemand/hcws/${id}`);
  }

  static async updateApproval(id, { action, reason, force } = {}) {
    return api.put(`/ondemand/hcws/${id}/approval`, { action, reason, force });
  }

  static async updateBackgroundCheck(id, { status, result, notes }) {
    return api.put(`/ondemand/hcws/${id}/background-check`, { status, result, notes });
  }

  static async getDocumentUrl(id, docId) {
    return api.get(`/ondemand/hcws/${id}/documents/${docId}/url`);
  }

  static async updateDocumentStatus(id, docId, { status, rejectionReason } = {}) {
    return api.put(`/ondemand/hcws/${id}/documents/${docId}/status`, {
      status,
      rejectionReason,
    });
  }

  static async getKitPhotoHistory(id) {
    return api.get(`/ondemand/hcws/${id}/kit-photo-history`);
  }
}

export default OnDemandHCWService;
